module.exports = __webpack_public_path__ + "img/4-4.f7513b11.png";